const ShortVideoPopup = {
    render: function () {
      $(".short-video-popup .short-video .short-video__main").each(function () {
        const toggle = $(this).closest(".short-video").find(".short-video__poster");
        const videoId = $(this).attr("id");
        const playlistId = $(this).attr("playlist-id");
  
        const player = new YT.Player(videoId, {
          videoId: videoId,
          width: 376,
          height: 700,
          playerVars: {
            autoplay: 0,
            controls: 1,
            start: 0,
            rel: 0,
            fs: 0,
            cc_load_policy: 0,
            iv_load_policy: 3,
            mute: 0,
          },
          events: {
            onReady: function () {
              toggle.parent().addClass("ready");
              player.seekTo(0).stopVideo();
            },
          },
        });
  
  
        const playBtn = $(".short-video-small__poster");
        const popupWrap = $(".short-video-popup-wrap");
        const closeBtn = $(".short-video-popup__close");
        const backdrop = $(".short-video-popup-wrap__backdrop");
        const mainButtons = $(".short-video-popup__btn-main");
        const secondaryBtn = $(".short-video-popup__btn-secondary");
  
        playBtn.on("click", function () {
          player.playVideo();
          popupWrap.toggleClass("hidden");
        })
  
        closeBtn.on("click", function () {
          player.stopVideo();
          popupWrap.toggleClass("hidden");
        })
  
        backdrop.on("click", function () {
          player.stopVideo();
          popupWrap.toggleClass("hidden");
        })
  
        mainButtons.each(function () {
          $(this).on("click", function () {
            player.stopVideo();
            popupWrap.toggleClass("hidden");
          })
        });
  
        secondaryBtn.on("click", function () {
          player.stopVideo();
          popupWrap.toggleClass("hidden");
        })
  
      });
    },
  };
  
  export default ShortVideoPopup;